import React from 'react';
import AudioList from '../components/routing/AudioList';

const RoutingAudioPage = () => {
    return (
        <AudioList />
    );
};

export default RoutingAudioPage;
